import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Numbers } from 'src/app/utils/constants';
import { RadioListModel } from '../../../../core/models/radio-list.model';
import { RadioModel } from '../../../../core/models/radio.model';
import { UtilsService } from '../../../services/utils/utils.service';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent implements OnInit, OnChanges {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: RadioListModel;
  @Input() DATA_CHANGE: RadioListModel;
  @Output() RADIO_S: EventEmitter<any> = new EventEmitter();

  listDuration = ['Temporal', 'Anual', 'Larga Estancia'];
  s1Duration = '';
  /**
   * @description constructor
   * @params utils
   */
  constructor(private utils: UtilsService) {
    this.utils = utils;
  }
  /**
   * @description metodo inicio
   */
  ngOnInit() {
    this.setValueInForm();
  }
  /**
   * @description metodo de cambio
   * @params changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.DATA_CHANGE && changes.DATA_CHANGE.currentValue) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      this.s1Duration = localStorage.getItem('s1Duration');
      if (AUX_CHANGE !== '') {
        setTimeout(() => {
          const AUX_OPTION: any = { label: AUX_CHANGE, text: '' };
          const IDX_LIST: number = this.listDuration.indexOf(AUX_CHANGE);
          const OLD_VALUE: string = this.s1Duration;
          if (OLD_VALUE !== AUX_CHANGE) {
            this.updateData(AUX_OPTION, IDX_LIST, true);
          }
        }, Numbers.number100);
      }
    }
  }
  /**
   * @description guardar valor en el formulario
   */
  setValueInForm(): void {
    if (this.FORM_DATA && this.DATA_CONFIG &&
      !this.FORM_DATA.get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration']).value && this.DATA_CONFIG.radioList &&
      this.DATA_CONFIG.radioList.length > 0) {
      this.DATA_CONFIG.radioList.forEach(element => {
        if (element.checked) {
          this.FORM_DATA
            .get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration'])
            .setValue(element.label);

          const LAVEL_VALUE: string = element.label;
          let lavelValue2: string = LAVEL_VALUE;
          if (LAVEL_VALUE.indexOf('form1') > -1) { lavelValue2 = this.utils.getTranslate(LAVEL_VALUE); }
          localStorage.setItem('s1Duration', lavelValue2);
        }
      });
    }
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }
  /**
   * @description actualizar datos
   * @params option
   * @params idx
   * @params change
   */
  public updateData(option: RadioModel, idx: number, change?: boolean): void {
    if (!this.checkDataCompOk()) { return; }

    this.DATA_CONFIG.radioList.forEach(e => e.checked = false);
    this.DATA_CONFIG.radioList[idx].checked = true;

    if (change) {
      this.FORM_DATA.get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration'])
        .setValue(option.label);
    } else {
      this.FORM_DATA.get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration'])
        .setValue(this.utils.getTranslate(option.label));
    }
    const LAVEL_VALUE: string = option.label;
    let lavelValue2: string = LAVEL_VALUE;
    if (LAVEL_VALUE.indexOf('form1') > -1) { lavelValue2 = this.utils.getTranslate(LAVEL_VALUE); }
    localStorage.setItem('s1Duration', lavelValue2);
    this.RADIO_S.emit({ id: idx, change });
  }
}
